import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { MFAImpersonateForm } from '../mfa-impersonate-form';

export const MFAImpersonateModal: React.FC<{ isOpen: boolean; onClose: Function }> = ({ isOpen, onClose }) => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(isOpen);

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  const handleModalClose = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <ReactModal
      isOpen={modalIsOpen}
      ariaHideApp={false}
      onRequestClose={handleModalClose}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '500px',
          maxWidth: '600px',
          height: '250px',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <MFAImpersonateForm setIsOpen={setIsOpen} />
    </ReactModal>
  );
};
